import { Chip } from "@mui/material";
import placeholder from 'Recursos/notFound.png';
import parse from 'html-react-parser';

export const TIPOS_APRENDIZAJE = {
    CURSO: 1,
    PAQUETE: 2
};

export const DIPLOMA_FIRMA_URL = "https://s3-capacitaciones-fge.s3.amazonaws.com/capacitacion-ed-dev/firma%20diplomas.png?AWSAccessKeyId=AKIAUMXX4GVXV4KVKKF2&Expires=1755024232&Signature=JSqCM6sn1pK85Y2S9qSM7GUNdvE%3D";

export const HTTP_METHODS = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    PATCH: "PATCH"
};

export const HTTP_HEADERS = {
    CONTENT_TYPE_JSON: "application/json",
    CONTENT_TYPE_FORM: "application/x-www-form-urlencoded",
    CONTENT_TYPE_MULTIPART: "multipart/form-data"
};

export const MODAL_TYPES = {
    BULK: "bulk",
    EDIT: "edit"
};

export const PAGINATION = {
    ITEMS_PER_PAGE_DESKTOP: 9,
    ITEMS_PER_PAGE_MOBILE: 10
};

export const TIPOS_CONTENIDO = {
    E_LEARNING: {
        ID: 1,
        NOMBRE: "E-learning",
        FORMATO: ".zip"
    },
    PDF: {
        ID: 2,
        NOMBRE: "PDF",
        FORMATO: ".pdf"
    },
    IMAGEN: {
        ID: 3,
        NOMBRE: "Imagen",
        FORMATO: ".jpg, .png, .gif, .svg, .jpeg, .webp"
    },
    VIDEO: {
        ID: 4,
        NOMBRE: "Video",
        FORMATO: ".mp4"
    },
    PREGUNTA: {
        ID: 5,
        NOMBRE: "Pregunta",
        FORMATO: ".pregunta"
    },
    ENCUESTA: {
        ID: 6,
        NOMBRE: "Encuesta",
        FORMATO: ".encuesta"
    },
    TEXTO: {
        ID: 7,
        NOMBRE: "Texto",
        FORMATO: ".texto"
    },
    TEXTO_MULTILINEA: {
        ID: 8,
        NOMBRE: "Texto Multilinea",
        FORMATO: ".area"
    },
    PLANTILLA: {
        ID: 9,
        NOMBRE: "Plantilla",
        FORMATO: ".plantilla"
    },
    LINK: {
        ID: 10,
        NOMBRE: "Hípervículo",
        FORMATO: ".link"
    }
};

export const EXTENSION_TO_ICON_MAP = {
    // Images
    'jpg': 'FileTypeJpgIcon',
    'jpeg': 'FileTypeJpgIcon',
    'png': 'FileTypePngIcon',
    'bmp': 'FileTypeBmpIcon',
    'svg': 'FileTypeSvgIcon',
    'gif': 'PhotoIcon',
    'webp': 'PhotoIcon',
    'tiff': 'PhotoIcon',
    'ico': 'PhotoIcon',

    // Videos
    'mp4': 'VideoIcon',
    'avi': 'VideoIcon',
    'mov': 'VideoIcon',
    'wmv': 'VideoIcon',
    'flv': 'VideoIcon',
    'webm': 'VideoIcon',
    'mkv': 'VideoIcon',
    'm4v': 'VideoIcon',
    '3gp': 'VideoIcon',
    'ogv': 'VideoIcon',

    // Audio
    'mp3': 'MusicIcon',
    'wav': 'MusicIcon',
    'flac': 'MusicIcon',
    'aac': 'MusicIcon',
    'ogg': 'MusicIcon',
    'wma': 'MusicIcon',
    'm4a': 'MusicIcon',
    'aiff': 'MusicIcon',
    'opus': 'MusicIcon',

    // Documents
    'pdf': 'FileTypePdfIcon',
    'doc': 'FileTypeDocIcon',
    'docx': 'FileTypeDocxIcon',
    'xls': 'FileTypeXlsIcon',
    'xlsx': 'FileTypeXlsIcon',
    'ppt': 'FileTypePptIcon',
    'pptx': 'FileTypePptIcon',
    'txt': 'FileTypeTxtIcon',
    'csv': 'FileTypeCsvIcon',
    'rtf': 'FileTextIcon',
    'odt': 'FileTextIcon',
    'ods': 'FileSpreadsheetIcon',
    'odp': 'PresentationIcon',

    // Web files
    'html': 'FileTypeHtmlIcon',
    'css': 'FileTypeCssIcon',
    'js': 'FileTypeJsIcon',
    'jsx': 'FileTypeJsxIcon',
    'ts': 'FileTypeTsIcon',
    'tsx': 'FileTypeTsxIcon',
    'php': 'FileTypePhpIcon',
    'vue': 'FileTypeVueIcon',
    'xml': 'FileTypeXmlIcon',
    'json': 'FileCodeIcon',
    'yaml': 'FileCodeIcon',
    'yml': 'FileCodeIcon',

    // Archives
    'zip': 'FileTypeZipIcon',
    'rar': 'FileZipIcon',
    '7z': 'FileZipIcon',
    'tar': 'FileZipIcon',
    'gz': 'FileZipIcon',
    'bz2': 'FileZipIcon',
    'xz': 'FileZipIcon',

    // Programming
    'sql': 'FileTypeSqlIcon',
    'rs': 'FileTypeRsIcon',
    'py': 'FileCodeIcon',
    'java': 'FileCodeIcon',
    'cpp': 'FileCodeIcon',
    'c': 'FileCodeIcon',
    'h': 'FileCodeIcon',
    'cs': 'FileCodeIcon',
    'go': 'FileCodeIcon',
    'rb': 'FileCodeIcon',
    'swift': 'FileCodeIcon',
    'kt': 'FileCodeIcon',
    'scala': 'FileCodeIcon',
    'r': 'FileCodeIcon',
    'pl': 'FileCodeIcon',
    'sh': 'FileCodeIcon',
    'bat': 'FileCodeIcon',
    'ps1': 'FileCodeIcon',

    // Other
    'exe': 'FileIcon',
    'dmg': 'FileIcon',
    'iso': 'FileIcon',
    'deb': 'FileIcon',
    'rpm': 'FileIcon',
    'apk': 'FileIcon',
    'ipa': 'FileIcon',
};

//ESTADOS
export const ESTADOS = [
    { nombre: 'Activo', valor: 1 },
    { nombre: 'Inactivo', valor: 0 },
]

export const tableLabels = {
    textLabels: {
        body: {
            noMatch: "Sin resultados para mostrar",
            toolTip: "Ordenar",
            columnHeaderTooltip: column => `ORDENAR POR ${column.label}`
        },
        pagination: {
            next: "Página siguiente",
            previous: "Página anterior",
            rowsPerPage: "Filas por página:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Exportar",
            print: "Imprimir",
            viewColumns: "Visualizar Columnas",
            filterTable: "Filtros",
        },
        filter: {
            all: "Todos",
            title: "FILTROS",
            reset: "REINICIAR",
        },
        viewColumns: {
            title: "Mostrar Columnas",
            titleAria: "Ocultar/Mostar columnas",
        },
        selectedRows: {
            text: "Filas(s) seleccionada(s)",
            delete: "Delete",
            deleteAria: "Delete Selected Rows",
        },
    }
}

export const tableOptions = {
    filterType: 'textField',
    selectableRows: 'none',
    responsive: 'standard',
    print: false,
    elevation: 0,
    searchOpen: true,
    download: false,
    ...tableLabels,
};



export const SECCIONES_COLUMNS = [
    {
        name: "idSegmento",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const SEGMENTO_EDUCTIVO_COLUMNS = [
    {
        name: "idSegmentoEducativo",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const ROL_COLUMNS = [
    {
        name: "idRol",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCIÓN",
        options: {
            filter: false,
            sort: true,
        }
    },
    {
        name: "minCapacita",
        label: "MÍNIMO CLIENTES POR CAPACITACIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "pantallaInicio",
        label: "PANTALLA INICIO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const PRODUCTO_COLUMNS = [
    {
        name: "idProducto",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const METODOLOGIA_EDUCATIVA_COLUMNS = [
    {
        name: "idMetodolodgiaEducativa",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const CURSOS_COLUMNS = (data = []) => [
    {
        name: "idCurso",
        label: "ID CURSO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idSubcategoria",
        label: "ID SUBCATEGORIA",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idCategoria",
        label: "ID CATEGORIA",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idDetalleCurso",
        label: "ID DETALLE CURSO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idIdioma",
        label: "ID IDIOMA",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idSegmento",
        label: "ID SECCIÓN",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idProducto",
        label: "ID PRODUCTO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idSegmentoEducativo",
        label: "ID SEGMENTO EDUCATIVO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idDificultad",
        label: "ID DIFICULTAD",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idMetodologiaEducativa",
        label: "ID METODOLOGÍA EDUCATIVA",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "codSegmento",
        label: "CÓDIGO SEGMENTO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "segmento",
        label: "SECCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "categoria",
        label: "PILAR",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "subcategoria",
        label: "SUB PILAR",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idioma",
        label: "IDIOMA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "metodologiaEducativa",
        label: "METODOLOGÍA EDUCATIVA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "segmentoEducativo",
        label: "SEGMENTO EDUCATIVO",
        options: {
            filter: true,
            sort: true,
            display: true,
            setCellHeaderProps: () => ({ align: "center" }),
            setCellProps: () => ({ align: "center" }),
            customBodyRenderLite: (dataIndex) => {
                const value = data[dataIndex]?.segmentoEducativo;
                return value ?? "No aplica";
            },
        },
    },
    {
        name: "producto",
        label: "PRODUCTO",
        options: {
            filter: true,
            sort: true,
            display: true,
            setCellHeaderProps: () => ({ align: "center" }),
            setCellProps: () => ({ align: "center" }),
            customBodyRenderLite: (dataIndex) => {
                const value = data[dataIndex]?.producto;
                return value ?? "No aplica";
            },
        },
    },
    {
        name: "dificultad",
        label: "DIFICULTAD",
        options: {
            filter: true,
            sort: true,
            display: true,
            setCellHeaderProps: () => ({ align: "center" }),
            setCellProps: () => ({ align: "center" }),
        },
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return (estado === 1 && filters[0] !== 'Activo') || (estado === 0 && filters[0] !== 'Inactivo');
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
    {
        name: "img",
        label: "IMAGEN",
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return (
                    <img
                        className='img-table'
                        alt="Curso"
                        src={value}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = placeholder;
                        }}
                    />
                );
            },
        }
    },
]

export const CONTENIDO_CURSO_COLUMNS = [
    {
        name: "idCurso",
        label: "ID CURSO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "tipoContenido",
        label: "Contenido",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "formato",
        label: "FORMATO ADMITIDO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const PILARES_COLUMNS = [
    {
        name: "idCategoria",
        label: "ID PILAR",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idSegmento",
        label: "ID SECCION",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "etiqueta",
        label: "ETIQUETA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "segmento",
        label: "SECCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "icono",
        label: "ICONO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => ({ align: "center" }),
            setCellProps: () => ({ align: "center" }),
        },
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const SUBPILAR_COLUMNS = [
    {
        name: "idSubcategoria",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idCategoria",
        label: "ID CATEGORIA",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "categoria",
        label: "CATEGORIA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]


export const NIVELES_COLUMNS = [
    {
        name: "idNivel",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "valor",
        label: "VALOR",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
    {
        name: "img",
        label: "IMAGEN",
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return (
                    <img
                        className='img-table'
                        alt="Nivel"
                        src={value}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = placeholder;
                        }}
                    />
                );
            },
        }
    },
];

export const MICROAPRENDIZAJE_COLUMNS = [
    {
        name: "idMicroaprendizaje",
        label: "ID MICROAPRENDIZAJE",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "etiqueta",
        label: "ETIQUETA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCION",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "curso",
        label: "CURSO",
        options: {
            display: true,
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const ENCUESTA_COLUMNS = [
    {
        name: "idEncuesta",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                const textoConSaltos = typeof value === 'string'
                    ? value.replace(/\\r\\n/g, '\n').replace(/\r\n/g, '\n')
                    : value;
                return (
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                        {textoConSaltos}
                    </div>
                );
            }
        }
    },
    {
        name: "instrucciones",
        label: "INSTRUCCIONES",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                const textoConSaltos = typeof value === 'string'
                    ? value.replace(/\\r\\n/g, '\n').replace(/\r\n/g, '\n')
                    : value;
                return (
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                        {textoConSaltos}
                    </div>
                );
            }
        }
    },
    {
        name: "segmento",
        label: "SECCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const PREGUNTA_COLUMNS = [
    {
        name: "idPregunta",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idTipoPregunta",
        label: "ID TIPO PREGUNTA",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "pregunta",
        label: "PREGUNTA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "tipoPregunta",
        label: "TIPO PREGUNTA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const CAMPANIA_COLUMNS = [
    {
        name: "idCampania",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idTipoCampania",
        label: "TIPO CAMPAÑA",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idMicroaprendizaje",
        label: "ID MICROAPRENDIZAJE",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idCurso",
        label: "ID CURSO",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "tipoCampania",
        label: "TIPO CAMPAÑA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "curso",
        label: "CURSO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "microaprendizaje",
        label: "MICROAPRENDIZAJE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "fechaEnvio",
        label: "FECHA ENVIO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                let d = new Date(value);
                return d.toLocaleString();
            },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
];

export const ERRORES_CARGA_CAMPANIA_COLUMNS = [
    {
        name: "rowNumber",
        label: "FILA",
        options: {
            sort: true,
            filter: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        },
    },
    {
        name: "dpi",
        label: "DPI",
        options: {
            sort: false,
            filter: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => value || "-",
        },
    },
    {
        name: "telefono",
        label: "TELÉFONO",
        options: {
            sort: false,
            filter: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => value || "-",
        },
    },
    {
        name: "reasons",
        label: "ERROR",
        options: {
            sort: false,
            filter: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) =>
                Array.isArray(value) ? value.join(" | ") : value,
        },
    },
];

export const OPCIONES_COLUMNS = [
    {
        name: "idOpcion",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "etiqueta",
        label: "ETIQUETA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idOptPadre",
        label: "ID PADRE",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return value > 0 ? value : 'No aplica';
            },
        }
    },
    {
        name: "modulo",
        label: "MODULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "tipo",
        label: "TIPO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "icono",
        label: "ICONO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return value ? value : 'No aplica';
            },
        }
    },
    {
        name: "movil",
        label: "MOVIL",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return value ? 'Si' : 'No';
            },
        }
    },
    {
        name: "mostrarMenu",
        label: "MOSTRAR EN MENU",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return value ? 'Si' : 'No';
            },
        }
    },
    {
        name: "idSegmento",
        label: "ID SEGMENTO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "segmento",
        label: "SECCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const DIFICULTAD_COLUMNS = [
    {
        name: "idDificultad",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const TIPO_APRENDIZAJE_COLUMNS = [
    {
        name: "idTipoAprendizaje",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    },
]

export const PAQUETE_CURSOS_COLUMNS = [
    {
        name: "idPaqueteCursos",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idCategoria",
        label: "ID CATEGORIA",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idIdioma",
        label: "ID IDIOMA",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "categoria",
        label: "CATEGORIA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idioma",
        label: "IDIOMA",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "duracion",
        label: "DURACIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: 'dropdown',
            filterOptions: {
                logic: (estado, filters) => {
                    return estado === 0 ? 'Activo' === filters[0] : 'Inactivo' === filters[0];
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? 'Activo' : 'Inactivo'}
                        color={value ? 'success' : 'error'}
                    />
                )
            },
        }
    }, {
        name: "img",
        label: "IMAGEN",
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return (
                    <img
                        className='img-table'
                        alt="Paquete de Cursos"
                        src={value}
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = placeholder;
                        }}
                    />
                );
            },
        }
    },
]

export const TUTORIAL_COLUMNS = [
    {
        name: "idContenidoTutorial",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "orden",
        label: "ORDEN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "titulo",
        label: "TITULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return <h6 className="tutorial-title">{parse(value)}</h6>
            }
        }
    },
    {
        name: "descripcion",
        label: "DESCRIPCIÓN",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return <h6 className="tutorial-description">{parse(value)}</h6>
            }
        }
    },
    {
        name: "archivo",
        label: "ARCHIVO",
        options: {
            display: false,
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "url",
        label: "IMAGEN",
        options: {
            filter: false,
            sort: false,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {

                const isVideo = value?.toLowerCase().includes(".mp4");

                return isVideo ? (
                    <video
                        controls
                        style={{ objectFit: "cover", borderRadius: "6px" }}
                    >
                        <source src={value} type="video/mp4" />
                        Tu navegador no soporta video.
                    </video>
                ) : (
                    <img
                        className="img-tutorial-table"
                        src={value}
                        alt="img"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = placeholder;
                        }}
                    />
                );
            }

        }
    },
]

//URI ARCHIVOS
export const fileUri = {
    elearning: 'elearning',
    actas: 'acta',
    portada: 'portada',
    contenido: 'contenido',
    casos: 'casos',
    microaprendizaje: 'microaprendizaje',
}

//DELAY TOAST
export const TOAST_DELAY = 4000;

//SELECTED CLIENTS COLUMNS 
export const CLIENTES_COLUMNS = [
    {
        name: "cliente",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "dpi",
        label: "DPI",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "codigo",
        label: "FUD",
        options: {
            display: true,
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
]

export const ALERTA_COLUMNS = [
    {
        name: "nombre",
        label: "CLIENTE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "mensaje",
        label: "MENSAJE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
]

export const NOTIFICACIONES_COLUMNS = (iconMap, getTipoAudienciaLabel) => [
    {
        name: "idNotificacion",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "titulo",
        label: "TÍTULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "icono",
        label: "ICONO",
        options: {
            filter: false,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
            customBodyRender: (value) => {
                const IconComp = iconMap[value];
                return IconComp ? (
                    <IconComp style={{ width: 24, height: 24, color: "#1976d2" }} />
                ) : (
                    value
                );
            },
        },
    },
    {
        name: "tipoAudiencia",
        label: "TIPO AUDIENCIA",
        options: {
            filter: true,
            sort: true,
            filterType: "dropdown",
            filterOptions: {
                names: [
                    "Todos los usuarios",
                    "Usuarios de un curso",
                    "Usuarios de un paquete",
                    "Bienvenida"
                ],
                logic: (tipoAudiencia, filterVal) => {
                    if (filterVal.length === 0) return false;
                    return !filterVal.includes(getTipoAudienciaLabel(tipoAudiencia));
                }
            },
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
            customBodyRender: (value) => {
                return getTipoAudienciaLabel(value);
            },
        },
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
            filterType: "dropdown",
            filterOptions: {
                logic: (estado, filters) => {
                    if (filters.length === 0) return false;
                    const selectedFilter = filters[0];
                    if (selectedFilter === "Activo") {
                        return !Boolean(estado);
                    }
                    if (selectedFilter === "Inactivo") {
                        return Boolean(estado);
                    }
                    return false;
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? "Activo" : "Inactivo"}
                        color={value ? "success" : "error"}
                    />
                );
            },
        },
    },
];

export const PLANTILLAS_COLUMNS = (iconMap) => [
    {
        name: "idPlantilla",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "nombre",
        label: "NOMBRE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "tituloPlantilla",
        label: "TÍTULO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
        },
    },
    {
        name: "icono",
        label: "ICONO",
        options: {
            filter: false,
            sort: true,
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
            customBodyRender: (value) => {
                const IconComp = iconMap[value];
                return IconComp ? (
                    <IconComp style={{ width: 24, height: 24, color: "#1976d2" }} />
                ) : (
                    value
                );
            },
        },
    },
    {
        name: "estado",
        label: "ESTADO",
        options: {
            setCellHeaderProps: () => {
                return { align: "center" };
            },
            setCellProps: () => {
                return { align: "center" };
            },
            filterType: "dropdown",
            filterOptions: {
                logic: (estado, filters) => {
                    if (filters.length === 0) return false;
                    const selectedFilter = filters[0];
                    if (selectedFilter === "Activo") {
                        return !Boolean(estado);
                    }
                    if (selectedFilter === "Inactivo") {
                        return Boolean(estado);
                    }
                    return false;
                },
                names: ["Activo", "Inactivo"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value ? "Activo" : "Inactivo"}
                        color={value ? "success" : "error"}
                    />
                );
            },
        },
    },
];

export const BLOQUEO_COLUMNS = [
    {
        name: "idBloqueo",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "idMotivoBloqueo",
        label: "ID",
        options: {
            display: false,
            filter: false,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "telefono",
        label: "TELEFONO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return `+${value}`
            },
        }
    },
    {
        name: "canal",
        label: "CANAL",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "motivo",
        label: "MOTIVO BLOQUEO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "detalle",
        label: "DETALLE",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "vigente",
        label: "Bloqueado",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            filterType: "dropdown",
            filterOptions: {
                logic: (vigente, filters) => {
                    return vigente === 0 ? 'Bloqueado' === filters[0] : 'Desbloqueado' === filters[0];
                },
                names: ["Bloqueado", "Desbloqueado"],
            },
            customBodyRender: (value) => {
                return (
                    <Chip
                        label={value > 0 ? "SI" : "NO"}
                        color={value <= 0 ? "success" : "error"}
                    />
                );
            },
        }
    },
    {
        name: "fechaInicio",
        label: "FECHA BLOQUEO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
        }
    },
    {
        name: "fechaFin",
        label: "FECHA DESBLOQUEO",
        options: {
            filter: true,
            sort: true,
            setCellHeaderProps: () => { return { align: "center" } },
            setCellProps: () => { return { align: "center" } },
            customBodyRender: (value) => {
                return value ?? 'NA'
            },
        }
    },
]


export const colors = [
    '#771878 0% 0% no-repeat padding-box',
    '#203689 0% 0% no-repeat padding-box',
    '#1FB7D6 0% 0% no-repeat padding-box',
    '#ED4D29 0% 0% no-repeat padding-box',
    '#96BF26 0% 0% no-repeat padding-box',
    '#024DA1 0% 0% no-repeat padding-box',
    '#00BEF4 0% 0% no-repeat padding-box',
    '#7B7B7B 0% 0% no-repeat padding-box',
    '#921F8F 0% 0% no-repeat padding-box',
    '#FDBD00 0% 0% no-repeat padding-box',
    '#15408F 0% 0% no-repeat padding-box',
    '#F3650E 0% 0% no-repeat padding-box',
    '#707070 0% 0% no-repeat padding-box',
    '#00256A 0% 0% no-repeat padding-box',
    '#0000004D 0% 0% no-repeat padding-box',
    '#000000 0% 0% no-repeat padding-box',
    '#0034C4 0% 0% no-repeat padding-box',
    '#232323 0% 0% no-repeat padding-box',
    '#238BFF 0% 0% no-repeat padding-box',
    '#D32F2F 0% 0% no-repeat padding-box',
    '#FFC107 0% 0% no-repeat padding-box',
    '#FF4081 0% 0% no-repeat padding-box',
    '#455A64 0% 0% no-repeat padding-box',
    '#795548 0% 0% no-repeat padding-box',
    '#4CAF50 0% 0% no-repeat padding-box',
    '#8BC34A 0% 0% no-repeat padding-box',
    '#CDDC39 0% 0% no-repeat padding-box',
];


//LIMITE DE CARACTERES
export const characterLimit30 = 30;
export const characterLimit50 = 50;
export const characterLimit100 = 100;
export const characterLimit150 = 150;
export const characterLimit200 = 200;
export const characterLimit250 = 250;

export const ULTIMO_CURSO = "ultimo-curso";
export const ULTIMO_PAQUETE = "ultimo-paquete";

export const ULTIMO_CURSO_ESTRUCTURA = {
    idCurso: null,
    progreso: {
        porcentajeTotal: 0,
        porcentajeMateriales: 0
    },
    materiales: [
        // Estructura de cada material:
        // {
        //   idContenidoCurso: number,
        //   completado: boolean
        // }
    ],
    encuesta: {
        idEncuesta: null,
        completada: false,
        idContenidoCurso: null,
        respuestas: [
            // Estructura de cada respuesta:
            // {
            //   idPregunta: number,
            //   idRespuesta: number
            // }
        ]
    }
};

export const ULTIMO_PAQUETE_ESTRUCTURA = {
    idPaquete: null,
    cursos: []
};

export const ESTADOS_ACTA = {
    INICIADA: {
        ID: 30,
        CODIGO: 'actaIniciada'
    },
    EN_CURSO: {
        ID: 31,
        CODIGO: 'actaEnCurso'
    },
    FINALIZADA: {
        ID: 32,
        CODIGO: 'actaFinalizada'
    }
};

export const TIPOS_FILTRO_REPORTERIA = {
    REGION: 'region',
    SUCURSAL: 'sucursal',
    SEGMENTO: 'segmento'
};

export const TIPOS_DISTRIBUCION = {
    DISTRITO: 'distrito',
    REGION: 'region',
    SUCURSAL: 'sucursal'
};

export const SEGMENTOS = {
    CAPACITACION: {
        ID: 1,
        CODIGO: 'capa'
    },
    CAPACITACION_AUTONOMA: {
        ID: 2,
        CODIGO: 'diplomado'
    },
    CAPACITACION_PERSONALIZADA: {
        ID: 75,
        CODIGO: 'personalizada'
    },
    CAPACITACION_ANONIMA: {
        ID: 76,
        CODIGO: 'anonimo'
    },
    WHATSAPP_EDUCATIVO: {
        ID: 69,
        CODIGO: 'wa'
    }
};

export const TIPOS_CLIENTE = {
    CLIENTE: {
        ID: 1,
        NOMBRE: "Cliente"
    },
    INVITADO: {
        ID: 2,
        NOMBRE: "Invitado"
    },
    AUTONOMO: {
        ID: 5,
        NOMBRE: "Autónomo"
    }
};

export const ROLES = {
    CLIENTE: {
        ID: 1,
        NOMBRE: "Cliente"
    },
    NO_CLIENTE: {
        ID: 2,
        NOMBRE: "No Cliente"
    },
    ADMINISTRADOR: {
        ID: 3,
        NOMBRE: "Administrador"
    },
    ASISTENTE: {
        ID: 4,
        NOMBRE: "Asistente"
    },
    OPERATIVO: {
        ID: 5,
        NOMBRE: "Operativo"
    },
    ASISTENTE_ROTATIVA: {
        ID: 47,
        NOMBRE: "Asistente Rotativa"
    },
    COORDINADOR_REGIONAL: {
        ID: 48,
        NOMBRE: "Coordinador Regional"
    },
    ANALISTA_WHATSAPP: {
        ID: 49,
        NOMBRE: "ANALISTA WHATSAPP EDUCATIVO"
    },
    CLIENTE_WHATSAPP: {
        ID: 56,
        NOMBRE: "Cliente WhatsApp Educativo"
    }
};

export const MESES = [
    { value: 1, label: "Enero" },
    { value: 2, label: "Febrero" },
    { value: 3, label: "Marzo" },
    { value: 4, label: "Abril" },
    { value: 5, label: "Mayo" },
    { value: 6, label: "Junio" },
    { value: 7, label: "Julio" },
    { value: 8, label: "Agosto" },
    { value: 9, label: "Septiembre" },
    { value: 10, label: "Octubre" },
    { value: 11, label: "Noviembre" },
    { value: 12, label: "Diciembre" },
];

